import React, { useState, useContext } from "react";
import "../../../conference/components/styles.css";
import ReactQuillEditor from "../../../../components/reactQuillEditor";
import { TextField, Tooltip } from "@material-ui/core";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { dateFormat } from "../../../../lib/functions";
import { createNotes } from "../../../../actions/configuration";
import { PayLoadCtx } from "../../../../lib/context";
import Loader from "../../../../lib/ui/loader/Loader";
import { toast } from "react-toastify";
import { Button } from "@material-ui/core";

const InternalNote = ({ data, setRes}) => {
    const { payload } = useContext(PayLoadCtx);
    const [notes, SetNotes] = useState({
        name: data?.patientData?.name,
        meetId: data?.patientData?.consultId,
        dob: data?.patientData?.dob, 
        place: "",
        notes: "",
        get: false,
    });
    const cancel = {
        name: data?.patientData?.name,
        dob: data?.patientData?.dob,
        place: "",
        notes:""
    }
    const [loading, setLoading] = useState(false);

    const parseDate = (date) => {
        if (!date) return "";
        const parsedDate = new Date(Number(date) || date);
        return parsedDate.toLocaleDateString('en-IN');
    };
    
    const formattedDate = parseDate(notes?.dob);

    const handleSubmitData = async () => {
        setLoading(true);
            let createbody = {
                doctorId: data?.doctorId,
                appointmentId: data?.appointmentId,
                clinicId: data?.clinicId,
                patientId: data?.patientId,
                subdomain: payload?.subdomain,
                meetingId: data?.patientData?.consultId,
                updatedAt: new Date(),
            };
            notes?.notes && notes?.notes !== "" && (createbody["notes"] = notes?.notes);
            notes?.name && notes?.name !== "" && (createbody["pname"] = notes?.name);
            notes?.dob && notes?.dob !== "" && (createbody["pdob"] = notes?.dob);
            notes?.place && notes?.place !== "" && (createbody["place"] = notes?.place);

            createNotes(createbody)
                .then((res) => {
                    if (res?.status) {
                        toast.success(res?.data, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        SetNotes({ ...notes, get: true });
                        setRes([createbody])
                    } else {
                        toast.error(res?.error, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                    }
                    setLoading(false);
                })
                .catch((e) => {
                    console.log("e.........:", e);
                    setLoading(false);
                });
    };


    return (
        <>
            {loading && <Loader />}
            <div className="flexCol">
                <div className="flexRow alignCntr">
                    <div className="flexAutuRow">
                        <div className="proCardAvtr">
                            <img src="/images/icons/doctor-default.png" alt="avatar" />
                        </div>
                    </div>
                    <div className="flexMinWidthRow">
                        <div className="flexWrap pdngXS">
                            <div className="oneFourthWidth flexInline pdngXXXS">
                                <div className="flexRow ">
                                    <div className="networkMinWidth  pdngHXS">
                                        <span className="headingSM ellipsisTxt">Name</span>
                                    </div>
                                    <div className="flexMinWidthRow  pdngHXS">
                                        : &nbsp;
                                            <TextField
                                                id="filled-hidden-label-small"
                                                defaultValue={notes?.name}
                                                size="small"
                                                onChange={(e) => SetNotes({ ...notes, name: e.target.value })}
                                            />
                                    </div>
                                </div>
                            </div>
                            <div className="oneFourthWidth flexInline pdngXXXS">
                                <div className="flexRow">
                                    <div className="networkMinWidth  pdngHXS">
                                        <span className="headingSM ellipsisTxt">Meet ID</span>
                                    </div>
                                    <div className="flexMinWidthRow  pdngHXS">
                                        : &nbsp;{" "}
                                        <span className="capitalTxt lightTxt titleHeading headingSM ellipsisTxt">{notes?.meetId}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="oneFourthWidth flexInline pdngXXXS">
                                <div className="flexRow">
                                    <div className="networkMinWidth  pdngHXS">
                                        <span className="headingSM ellipsisTxt">DOB</span>
                                    </div>
                                    <div className="flexMinWidthRow pdngHXS">
                                        : &nbsp;
                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                <KeyboardDatePicker
                                                    inputVariant="standard"
                                                    className="pickerInput"
                                                    value={dateFormat(notes.dob) !== 'Invalid Date'?notes.dob:formattedDate}
                                                    onChange={(date) => SetNotes({ ...notes, dob: date })}
                                                    animateYearScrolling
                                                    placeholdertext="From Date"
                                                    format="dd/MM/yyyy"
                                                    size="small"
                                                />
                                            </MuiPickersUtilsProvider>
                                    </div>
                                </div>
                            </div>
                            <div className="oneFourthWidth flexInline pdngXXXS">
                                <div className="flexRow">
                                    <div className="networkMinWidth  pdngHXS">
                                        <span className="headingSM ellipsisTxt">Place</span>
                                    </div>
                                    <div className="flexMinWidthRow  pdngHXS">
                                        : &nbsp;{" "}
                                            <TextField
                                                id="filled-hidden-label-small"
                                                defaultValue={notes?.place}
                                                size="small"
                                                onChange={(e) => SetNotes({ ...notes, place: e.target.value })}
                                            />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex">
                        <div className="pdngXS">
                            <ReactQuillEditor
                                type="certificate"
                                placeholder="Terms & Conditions"
                                name="notes"
                                textData={notes?.notes}
                                setTextData={(value) => SetNotes({ ...notes, notes: value })}
                            />
                        </div>
                        <div className="flexRow justfiyEnd alignEnd pdngSM">
                                <>
                                    <div className="pdngHXSM">
                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            size="small"
                                            onClick={() =>
                                                SetNotes({
                                                    ...notes,
                                                    name: cancel?.name,
                                                    dob: cancel?.dob,
                                                    place: cancel?.place,
                                                    notes: cancel?.notes
                                                })
                                            }
                                        >
                                            cancel
                                        </Button>
                                    </div>
                                    <Button
                                        buttonType="submit"
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        className="whiteTxt"
                                        onClick={handleSubmitData}
                                    >
                                        save
                                    </Button>
                                </>
                        </div>
                </div>
            </div>
        </>
    );
};
export default InternalNote;
